import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {ElasticMenuItem} from '@models/elasticSearch/menu/elastic-menu-item';
import {DesignService} from '@services/left-menu/design/design.service';

@Component({
    selector: 'scitis-search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.scss'],
    standalone: false
})
export class SearchResultComponent implements OnChanges {

  @Input()
  public searchResults: ElasticMenuItem[] = [];
  @Input()
  public searchResultTotalCount: number = 0;
  @Input()
  public firebaseUserId: string = '';

  @Input()
  searchTerms: string[] = [];

  @Input()
  searchInProgress: boolean = false;

  @Output()
  menuItemSelected: EventEmitter<ElasticMenuItem> = new EventEmitter<ElasticMenuItem>();

  @Output()
  resetSearch: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  loadMoreItems: EventEmitter<boolean> = new EventEmitter<boolean>();


  summary = '';

  constructor(private translate: TranslateService, private designService: DesignService) {
  }

  public get shouldShowLoadButton(): boolean {
    if (this.searchInProgress) {
      return true;
    }
    if (this.searchResultTotalCount === 0) {
      return false;
    }
    if (!this.searchTerms || this.searchTerms.length === 0) {
      return false;
    }

    if (!this.searchResults || this.searchResults.length === 0 || this.searchResults.length === this.searchResultTotalCount) {
      return false;
    }

    return true;

  }

  public onLoadMoreItems() {
    this.loadMoreItems.emit(true);
  }

  onMenuItemSelected(menuItem: ElasticMenuItem): void {
    this.menuItemSelected.emit(menuItem);
  }

  onResetSearch(): void {
    this.resetSearch.emit(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes) {
      return;
    }

    if (changes.searchResultTotalCount || changes.searchInProgress) {
      this.setResultSummary();
    }
  }


  private setResultSummary() {
    if (this.searchInProgress) {
      this.summary = this.translate.instant('Searching') + '...';
      return;
    }

    if (this.searchResultTotalCount > 0) {
      this.setIconAndUserId();
      this.summary = this.translate.instant('Search produced %s results.').replace('%s', String(this.searchResultTotalCount).toBold());
      return;
    }
    this.summary = this.translate.instant('Nothing found.');
  }


  private setIconAndUserId() {
    for (const item of this.searchResults) {
      item.icon = this.designService.getIcon(item.type);
      if (!item.firebaseUserId && this.firebaseUserId) {
        item.firebaseUserId = this.firebaseUserId;
      }
    }
  }

}
